var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container",staticStyle:{"overflow":"hidden"}},[_c('web-header'),_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path=='/'),expression:"$route.path=='/'"}]},[_c('web-ad')],1),_c('web-foot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }